import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Eleves from './pages/Eleves';
import Classes from './pages/Classes';
import Inscriptions from './pages/Inscriptions';
import Paiements from './pages/Paiements';
import EvaluationsPage from './pages/EvaluationsPage';
import Users from './pages/Users';
import Parents from './pages/Parents';
import Profile from './pages/Profile';
import Unauthorized from './pages/Unauthorized';
import Home from './pages/Home';
import RolesPermissions from './pages/RolesPermissions';
import TypeParentePage from './pages/TypeParentePage';
import { AuthProvider } from './contexts/AuthContext';
import { AcademicYearProvider } from './contexts/AcademicYearContext';
import PrivateRoute from './components/PrivateRoute';
import ProtectedRoute from './components/ProtectedRoute';
import ProfessionPage from './pages/ProfessionPage';
import ReligionPage from './pages/ReligionPage';
import OuverturesClassesPage from './pages/OuverturesClassesPage';
import Cycles from './pages/Cycles';
import BranchesPage from './pages/BranchesPage';
import PeriodesPage from './pages/PeriodesPage';
import MatieresPage from './pages/MatieresPage';
import TypeEvaluationsPage from './pages/TypeEvaluationsPage';
import ClasseMatieresPage from './pages/ClasseMatieresPage';
import ProfesseursPage from './pages/ProfesseursPage';
import NiveauQualifProfPage from './pages/NiveauQualifProfPage';
import ProfQualifPage from './pages/ProfQualifPage';
import QualificationsPage from './pages/QualificationsPage';
import IncidentsPage from './pages/IncidentsPage';
import AbsencesPage from './pages/AbsencesPage';
import EtablissementPage from './pages/EtablissementPage';
import AnneesScolairesPage from './pages/AnneesScolairesPage';
import NotificationsAdminPage from './pages/NotificationsAdminPage';



const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AcademicYearProvider>
          <Router>
              <div className="App">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                  <Route path="/app" element={<PrivateRoute><Layout /></PrivateRoute>}>
                    <Route index element={<Navigate to="/app/dashboard" replace />} />
                    <Route path="dashboard" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant', 'enseignant']}>
                        <Dashboard />
                      </ProtectedRoute>
                    } />
                    <Route path="profile" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant', 'enseignant']}>
                        <Profile />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="eleves" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <Eleves />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="parents" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <Parents />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="classes" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <Classes />
                      </ProtectedRoute>
                    } />
                    <Route path="ouvertures-classes" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant', 'enseignant']}>
                        <OuverturesClassesPage />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="inscriptions" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <Inscriptions />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="paiements" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <Paiements />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="evaluations" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <EvaluationsPage />
                      </ProtectedRoute>
                    } />
                    
                    <Route path="users" element={
                      <ProtectedRoute allowedRoles={['admin']}>
                        <Users />
                      </ProtectedRoute>
                    } />
                    <Route path="roles-permissions" element={
                      <ProtectedRoute allowedRoles={['admin']}>
                        <RolesPermissions />
                      </ProtectedRoute>
                    } />
                    <Route path="types-parentes" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <TypeParentePage />
                      </ProtectedRoute>
                    } />
                    <Route path="professions" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <ProfessionPage />
                      </ProtectedRoute>
                    } />
                    <Route path="religions" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <ReligionPage />
                      </ProtectedRoute>
                    } />
                    <Route path="cycles" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <Cycles />
                      </ProtectedRoute>
                    } />
                    <Route path="branches" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <BranchesPage />
                      </ProtectedRoute>
                    } />
                    <Route path="periodes" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <PeriodesPage />
                      </ProtectedRoute>
                    } />
                    <Route path="matieres" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <MatieresPage />
                      </ProtectedRoute>
                    } />
                    <Route path="type-evaluations" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <TypeEvaluationsPage />
                      </ProtectedRoute>
                    } />
                    <Route path="classe-matieres" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <ClasseMatieresPage />
                      </ProtectedRoute>
                    } />
                    <Route path="professeurs" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <ProfesseursPage />
                      </ProtectedRoute>
                    } />
                    <Route path="niveau-qualif-prof" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <NiveauQualifProfPage />
                      </ProtectedRoute>
                    } />
                    <Route path="prof-qualif" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <ProfQualifPage />
                      </ProtectedRoute>
                    } />
                    <Route path="qualifications" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <QualificationsPage />
                      </ProtectedRoute>
                    } />
                    <Route path="absences" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire', 'intendant']}>
                        <AbsencesPage />
                      </ProtectedRoute>
                    } />
                    <Route path="incidents" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <IncidentsPage />
                      </ProtectedRoute>
                    } /> 
                    <Route path="etablissement" element={
                      <ProtectedRoute allowedRoles={['admin']}>
                        <EtablissementPage />
                      </ProtectedRoute>
                    } /> 
                    <Route path="annees-scolaires" element={
                      <ProtectedRoute allowedRoles={['admin', 'secretaire']}>
                        <AnneesScolairesPage />
                      </ProtectedRoute>
                    } />
                    <Route path="notifications-admin" element={
                      <ProtectedRoute allowedRoles={['admin']}>
                        <NotificationsAdminPage />
                      </ProtectedRoute>
                    } /> 
                    </Route>
                  </Routes>
                <ToastContainer position="top-right" />
              </div>
            </Router>
          </AcademicYearProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;